<app-spinner *ngIf="loading" fill></app-spinner>

<div class="events-container" (scroll)="onScroll($event)" *ngIf="!loading">
  <div *ngIf="!loading" class="card-container">
    <div #metricElems class="card-wrapper" *ngFor="let metric of metrics; let i = index" [id]="'metric-' + metric.id">
      <mat-card class="metric-card">
        <mat-card-content class="card-content">
          <app-gallery class="gallery" *ngIf="metric && metric.gallery && metric.gallery.url" [id]="metric.gallery.id"
            [index]="i" [name]="metric.gallery.name"
            [prediction]="metric.payload.prediction || metric.gallery.prediction" [craneCycle]="metric.payload.title"
            [startDate]="metric.payload.startDate" [endDate]="metric.payload.endDate" [url]="metric.gallery.url"
            [tags]="metric.gallery.tags" [project]="currentProject" [metric]="metric" [tracker]="metric.tracker"
            [tagNames]="tagNames" [isDialog]="false" [user]="user" [tagDisplayConfig]="tagDisplayConfig"
            [customVisionIds]="metric.gallery.customVisionIds" [processed]="metric.gallery.processed">
          </app-gallery>

          <img src="/img/default_project.png" alt="Default metric" class="gallery-img" *ngIf="!metric.gallery?.url">

          <div class="metric-info">
            <div class="metric-header">
              <h3 class="metric-title">{{ metric.payload.title }}</h3>

              <p class="metric-unit">{{ getUnitOrTrackerName(metric) }}</p>
            </div>

            @if(metric.payload.action){
            <p class="metric-date">
              {{ 'datatable.action' | translate }}: {{ metric.payload.action }}
            </p>
            }
            @if(metric.payload.zone){
            <p class="metric-date">
              {{ 'datatable.zone' | translate }}: {{ metric.payload.zone }}
            </p>
            }
            <p class="metric-date">
              {{ 'events.start' | translate }}: {{ metric.payload.startDate | date: 'dd-MM-yyyy HH:mm' }}
            </p>

            <p class="metric-date">
              {{ 'events.end' | translate }}: {{ metric.payload.endDate | date: 'dd-MM-yyyy HH:mm' }}
            </p>

            <p class="metric-duration">
              {{'events.duration' | translate }}: {{ metric.payload.duration }}
            </p>

            <div class="attachments-container" *ngIf="metric.attachments && metric.attachments.length">
              <img *ngFor="let attachment of metric.attachments" [src]="attachment.thumbnail"
                [alt]="attachment.prediction"
                class="attachment {{ attachment.id == metric.gallery.id ? 'active' : ''}} {{ isTagged(attachment) ? 'tagged' : ''}}"
                (click)="onThumbnailClick(metric, attachment)"
                [ngClass]="{ small: metric.attachments.length > 10, medium: metric.attachments.length > 5 }" />
            </div>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <!-- Add any action buttons, like edit or delete -->
        </mat-card-actions>
      </mat-card>
    </div>
  </div>

  <div *ngIf="scrollLoading && !noData" class="scroll-loading">
    <mat-spinner diameter="50" class="example-spinner">
      <mat-icon class="example-icon">loop</mat-icon>
    </mat-spinner>
  </div>

  <ng-container *ngIf="noData && !scrollLoading">
    <lib-no-data></lib-no-data>
  </ng-container>
</div>